import type { OatfiBusiness, OatfiBusinessFormFields } from 'src/interfaces/oatfiBusiness'

/**
 * Every field is a string in the form, so a null from the wire becomes ''. `toOatfiBusinessBody`
 * in `sagas/oatfiBusiness.ts` is the inverse and drops the empty optionals again.
 *
 * `requestedCreditLimit` is compared against null/undefined rather than tested for falsiness: a
 * stored 0 is a real requested limit and must round-trip as '0'.
 */
export function toFormValues(business: OatfiBusiness | null): OatfiBusinessFormFields {
  if (business === null) {
    return {
      name: '',
      city: '',
      streetAddress: '',
      state: '',
      postalCode: '',
      taxId: '',
      contactFirstName: '',
      contactLastName: '',
      contactPhoneNumber: '',
      dbaName: '',
      contactEmail: '',
      businessStartDateMonth: '',
      businessStartDateYear: '',
      businessEntityType: '',
      requestedLimitSource: '',
      requestedCreditLimit: '',
    }
  }

  return {
    name: business.name,
    city: business.city ?? '',
    streetAddress: business.streetAddress ?? '',
    state: business.state ?? '',
    postalCode: business.postalCode ?? '',
    taxId: business.taxId ?? '',
    contactFirstName: business.contactFirstName ?? '',
    contactLastName: business.contactLastName ?? '',
    contactPhoneNumber: business.contactPhoneNumber ?? '',
    dbaName: business.dbaName ?? '',
    contactEmail: business.contactEmail ?? '',
    businessStartDateMonth: business.businessStartDateMonth ?? '',
    businessStartDateYear: business.businessStartDateYear ?? '',
    businessEntityType: business.businessEntityType ?? '',
    requestedLimitSource: business.requestedLimitSource ?? '',
    requestedCreditLimit:
      business.requestedCreditLimit === null || business.requestedCreditLimit === undefined
        ? ''
        : String(business.requestedCreditLimit),
  }
}
